<template>
  <div class="line-item-summary">
    <h2 class="line-item-summary__title">
      {{ $t('cart.line_item_summary_title') }}
    </h2>

    <item-promotion-percentage
      v-for="(item, index) in summary.promotionItems"
      :key="index"
      :item="item"
    ></item-promotion-percentage>

    <item-promotion-percentage
      v-for="(item, index) in filteredLineItems"
      :key="index"
      :item="item"
    ></item-promotion-percentage>

    <div class="line-item-summary__item">
      <span class="line-item-summary__item-label"
        >{{ $t('order_sub_total') }}:</span
      >
      <span class="line-item-summary__item-price">
        {{ $isGlobalStore ? orderTotal : formatPrice(orderTotal) }}
      </span>
    </div>

    <div
      v-if="loadingShipping"
      class="line-item-summary__item line-item-summary__item--loading"
    >
      <span class="line-item-summary__item-label">{{ $t('shipping') }}:</span>
      <span><three-dots-loading /></span>
    </div>
    <div
      v-else-if="
        !loadingShipping &&
        summary.shipmentTotal &&
        (($isBrStore && summary.shipmentTotal > 0) || $isGlobalStore)
      "
      class="line-item-summary__item"
    >
      <span class="line-item-summary__item-label">{{ $t('shipping') }}:</span>
      <span
        :class="[
          'line-item-summary__item-price',
          { 'line-item-summary__item-free': freeShipping },
        ]"
      >
        {{
          $isGlobalStore
            ? freeShipping
              ? $t('free')
              : summary.shipmentTotal
            : formatPrice(summary.shipmentTotal)
        }}
      </span>
    </div>
  </div>
</template>

<script>
import priceable from '~/mixins/priceable'
import ThreeDotsLoading from '~/components/loadings/three-dots/ThreeDotsLoading.vue'
import ItemPromotionPercentage from '~/components/cart/item-promotion-percentage/ItemPromotionPercentage.vue'

export default {
  components: {
    ThreeDotsLoading,
    ItemPromotionPercentage,
  },
  mixins: [priceable],
  props: {
    summary: {
      type: Object,
      required: true,
    },
    loadingShipping: {
      type: Boolean,
      default: false,
    },
    freeShipping: {
      type: Boolean,
      default: false,
    },
    discountTotal: {
      type: Number,
      required: true,
    },
    itemsCalcutedPromotion: {
      type: Array,
      required: true,
    },
  },
  computed: {
    hasPromoItems() {
      return this.summary.promotionItems.length !== 0
    },
    orderTotal() {
      return Math.abs(this.discountTotal) + Math.abs(this.summary.total)
    },
    filteredLineItems() {
      let itemsInfo = []

      const groupedItems = {}
      this.summary.lineItems.forEach((li) => {
        if (!li.gift) {
          const key = `${li.name}&${li.price}`
          if (groupedItems[key]) {
            groupedItems[key].quantity += li.quantity
          } else {
            groupedItems[key] = { ...li }
          }
        }
      })

      Object.values(groupedItems).forEach((item) => {
        const quantity = item.quantity

        const itemInPromotion = this.itemsCalcutedPromotion?.find(
          (pil) =>
            pil.label?.match(item.name) && pil.actual_price === item.price
        )

        const price = itemInPromotion?.price || item.price

        const truncatedName = this.truncateName(item.name)
        const itemLabel = `${truncatedName} x ${quantity}`
        itemsInfo.push({ label: itemLabel, total: price * quantity })
      })

      const promotionItemsLabels = this.summary.promotionItems.map(
        (promotion) => promotion.label
      )

      itemsInfo = itemsInfo.filter(
        (item) =>
          !promotionItemsLabels?.find((pil) =>
            pil
              .split(' x')[0]
              .split('.')[0]
              .match(item.label?.split(' x')[0].split('.')[0])
          )
      )

      return itemsInfo
    },
  },
  methods: {
    updateCart(cart) {
      this.$emit('updateCart', cart)
    },
    truncateName(name) {
      if (name.length > 25) {
        return name.substring(0, 25) + '...'
      }
      return name
    },
  },
}
</script>

<style lang="scss" scoped>
.line-item-summary {
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  line-height: normal;
  padding: 10px 18px;
  width: 100%;
  border-bottom: 1px solid #e6e6ea;

  .line-item-summary__title {
    font-size: 17px;
    font-weight: 700;
    padding-bottom: 10px;
  }

  .line-item-summary__item-free {
    color: $v4_color_primary;
  }

  .line-item-summary__item--total {
    td {
      font-weight: 700;
    }
  }

  .line-item-summary__item--loading {
    td {
      padding-left: 20px;
      height: 18px;
    }
  }

  .line-item-summary__item {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    align-items: center;
    text-align: right;
    font-size: 15px;
    padding-bottom: 5px;

    .line-item-summary__item-label {
      color: #a2a2a6;
      font-weight: 400;
    }

    .line-item-summary__item-price {
      width: 80px;
    }
  }
}
</style>
